import { render } from "./FixedWhatsUp.vue?vue&type=template&id=705ca0e5"
import script from "./FixedWhatsUp.vue?vue&type=script&lang=js"
export * from "./FixedWhatsUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__